import React, { useState } from 'react';
import { format } from 'date-fns';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  IconButton,
  InputAdornment,
  TextField,
} from '@material-ui/core';
import { Cancel, Close, Done } from '@material-ui/icons';
import { IRealEstateEvent } from '../interfaces';
import { useExtendRealEstateEvent } from '../hooks';

interface IProps extends DialogProps {
  realEstateEvent: IRealEstateEvent;
  onClose(): void;
  onExtend?(extendDate: string): void;
}

const ExtendEventDialog = ({ realEstateEvent, onExtend, onClose, ...props }: IProps) => {
  const [extendDate, setExtendDate] = useState(realEstateEvent.eventEndTime);

  const { extendEventState, handleExtendEvent } = useExtendRealEstateEvent(
    realEstateEvent.realEstateEventId!,
    extendDate,
    () => {
      onClose();
      if (onExtend) onExtend(extendDate);
    },
  );

  return (
    <Dialog {...props} onClose={onClose} fullWidth maxWidth="sm" scroll="body">
      <DialogTitle>
        <b>Продлить событие</b>
      </DialogTitle>

      <DialogContent dividers>
        <TextField
          label="Дата окончания"
          type="datetime-local"
          variant="outlined"
          value={extendDate}
          onChange={(event) => setExtendDate(event.target.value)}
          inputProps={{
            min:
              format(new Date(realEstateEvent.eventEndTime), 'yyyy-MM-dd') +
              'T' +
              format(new Date(realEstateEvent.eventEndTime), 'HH:mm'),
          }}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                <IconButton size="small" onClick={() => setExtendDate('')}>
                  <Close />
                </IconButton>
              </InputAdornment>
            ),
          }}
          fullWidth
          disabled={extendEventState.loading}
        />
      </DialogContent>

      <DialogActions>
        <Button variant="contained" disabled={extendEventState.loading} onClick={onClose} startIcon={<Cancel />}>
          Отменить
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleExtendEvent}
          disabled={!Boolean(extendDate) || extendEventState.loading}
          startIcon={<Done />}
        >
          Сохранить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExtendEventDialog;
